module.exports = __webpack_public_path__ + "media/sfx.ea22997b.mp3";